import axios from 'axios';

import { VUE_APP_API_URL } from '@/utilities/constants.js';

export const state = initialState();

export const actions = {
  getMailTemplates: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`${VUE_APP_API_URL}/mail-templates`, {
        params: { ...payload }
      });

      commit('mutateMailTemplates', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {
  mutateMailTemplates: (state, payload) => {
    state.mailTemplates = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    mailTemplates: []
  };
}
